var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"object_pass-ppr"},[_c('span',[_vm._v(_vm._s(_vm.locales["ppr_object_passport"][_vm.current_locale]["plug"]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }